import * as React from "react";

function ArrowRightIcon({ className, height, width, color = "currentColor" }) {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width={width}
      height={height}
      viewBox="0 0 61 33"
      fill={color}
    >
      <defs>
        <clipPath id="clip-Arrow_svg">
          <rect width="61" height="33" />
        </clipPath>
      </defs>
      <g id="Arrow_svg" data-name="Arrow svg" clipPath="url(#clip-Arrow_svg)">
        <g
          id="Group_4766"
          data-name="Group 4766"
          transform="translate(-392.25 -635.5)"
        >
          <line
            id="Line_4"
            data-name="Line 4"
            x2="43"
            transform="translate(399.5 651.5)"
            fill="none"
            stroke={color}
            strokeLinecap="round"
            strokeWidth="2.5"
          />
          <line
            id="Line_5"
            data-name="Line 5"
            x2="13"
            y2="10"
            transform="translate(430.5 641.5)"
            fill="none"
            stroke={color}
            strokeLinecap="round"
            strokeWidth="2.5"
          />
          <line
            id="Line_6"
            data-name="Line 6"
            y1="10"
            x2="13"
            transform="translate(430.5 651.5)"
            fill="none"
            stroke={color}
            strokeLinecap="round"
            strokeWidth="2.5"
          />
        </g>
      </g>
    </svg>
  );
}

export default ArrowRightIcon;
